import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IDatatableOutputDTO,
  IDatatableParams,
} from 'src/app/shared/datatables/datatables';
import { HttpParamsMapper } from 'src/app/shared/mappers/http-params.mapper';

@Injectable({ providedIn: 'root' })
export class DelayedAttendanceReportService {
  url = `${environment.api}/delayed-attendance-report`;

  constructor(private readonly http: HttpClient) { }

  search({ filter, page, perPage }: IDatatableParams): Observable<IDatatableOutputDTO<any>> {
    const params = HttpParamsMapper.toHttpParams({
      filter: JSON.stringify(filter ?? {}),
      page,
      perPage,
    });
    return this.http.get<IDatatableOutputDTO<any>>(this.url, { params });
  }

  exportCsv(filter: any): Observable<HttpResponse<Blob>> {
    return this.http.get<Blob>(`${this.url}/export`, {
      params: { filter: JSON.stringify(filter ?? {}) },
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}